export const CUSTOM_NAV_BAR_ADMIN_FLAG_DISMISSED =
	'jira.user.theme.custom-nav-bar-admin-flag.dismissed' as const;

export const CUSTOM_THEME_ADMIN_FLAG_ID = 'jira.user.theme.custom-nav-bar-admin-flag.id' as const;
